import { westernDigits } from "./maintenance-format";

/** Shared UI labels only. User-entered branch names and identifiers bypass this. */
const common: Record<string, string> = {
  "vs":"مقابل", "Before":"الفترة السابقة", "Before:":"الفترة السابقة:",
  "Average / branch":"المتوسط لكل فرع", "By branch":"حسب الفرع",
  "Highest branch":"الفرع الأعلى تكلفة", "Sort: average / branch":"الترتيب: المتوسط لكل فرع",
  "Sort: branch and name":"الترتيب: الفرع والاسم",
  "Setup to finish":"إعدادات لم تكتمل بعد",
  "Filters":"عوامل التصفية", "Code":"الرمز", "بالعربي":"بالعربية",
  "Next":"التالي", "Back":"رجوع", "Close":"إغلاق",
  "Could not load smallwares.":"تعذر تحميل الأدوات الصغيرة.",
  "Could not load spare parts.":"تعذر تحميل قطع الغيار.",
  "Payments with spare parts":"دفعات تشمل قطع الغيار",
  "set":"مجموعة", "pack":"عبوة",
  "Bulk upload areas":"رفع المناطق دفعة واحدة",
  "Bulk upload people":"رفع الأشخاص دفعة واحدة",
  "Bulk upload equipment":"رفع المعدات دفعة واحدة",
  "Bulk upload spare parts":"رفع قطع الغيار دفعة واحدة",
  "Bulk upload smallwares":"رفع الأدوات الصغيرة دفعة واحدة",
  "Add part":"إضافة قطعة",
  "name":"الاسم بالإنجليزية","nameAr":"الاسم بالعربية","unit":"الوحدة","warrantyMonths":"الضمان بالأشهر",
};
export function maintenanceLabel(value: string, rtl: boolean, dictionary: Record<string, string>, fallback?: (key: string, rtl: boolean) => string): string {
  // Modal headings may have been opened in either language. Resolve a known UI
  // label back to its key rather than reinitializing modal/form state.
  const key = Object.keys(dictionary).find(k => dictionary[k] === value)
    || Object.keys(common).find(k => common[k] === value) || value;
  if(!rtl)return fallback?.(key,false)||key;
  const text=westernDigits(common[key]||dictionary[key]||fallback?.(key,true)||key).replace(/\s+([.،])/g,"$1");
  const count=text.match(/^(\d+)\s+(branches?|locations?|فروع|فرعان|فرعين|مواقع|موقعين|items?|أصناف|صنفان|صنفين|jobs?|أعمال|عملان|عملين|machines?|معدات|معدتان|معدتين|people|أشخاص|persons?|areas?|مناطق|categories|فئات|problems?|مشكلات)$/i);
  if(!count)return text;
  const unit=count[2].toLowerCase();
  const label=/branch|location|فرع|فروع|موقع|مواقع/.test(unit)?"عدد الفروع":/item|صنف|أصناف/.test(unit)?"عدد الأصناف":/job|عمل|أعمال/.test(unit)?"عدد الأعمال":/machine|معد|معدات/.test(unit)?"عدد المعدات":/people|person|أشخاص/.test(unit)?"عدد الأشخاص":/area|مناطق/.test(unit)?"عدد المناطق":/categor|فئات/.test(unit)?"عدد الفئات":"عدد المشكلات";
  return `${label}: ${count[1]}`;
}
